import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

import RightArrow from '../../assets/images/right-arrow.png';

export default function RealEstateDevelopment() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>
          Starlife: Real Estate Development & Strategic Acquisitions
        </title>
        <meta
          name='description'
          content='We source and develop high-impact residential and mixed-use projects across key markets. Our team identifies promising sites, navigates zoning and entitlements, and moves decisively from acquisition to execution. Every property we develop is a blend of creativity, performance, and purpose.'
        />
        <meta
          name='keywords'
          content='Starlife, Real Estate Development, Strategic Acquisitions, residential projects, mixed-use projects, property development, real estate investment'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          Real Estate Development & Strategic Acquisitions
        </h2>
        <p className='service-page-text'>
          We source and develop high-impact residential and mixed-use projects
          across key markets. Our team identifies promising sites, navigates
          zoning and entitlements, and moves decisively from acquisition to
          execution. Every property we develop is a blend of creativity,
          performance, and purpose.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Other Services</h2>
        <div className='service-list'>
          <Link
            to={ROUTE_NAMES.PREDEVELOPMENTPLANNING}
            className='service-block'
          >
            <h3>Pre-Development Planning</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.DESIGNBUILD}
            className='service-block green-block'
          >
            <h3>Design-Build & Construction Management</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link to={ROUTE_NAMES.SMARTSUSTAINABLE} className='service-block'>
            <h3>Smart & Sustainable Building Solutions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
